export default __webpack_public_path__ + "static/media/7SJ63.d9311679.jpg";